import React, { useState } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStores } from '@store';
import {
  HomeOutlined,
  SolutionOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  ShopOutlined,
  ShoppingOutlined,
  ProfileOutlined,
  AccountBookOutlined,
  ApartmentOutlined,
  NotificationOutlined,
} from '@ant-design/icons';
import s from './index.module';

const { Item, SubMenu } = Menu;

const router = {
  home: 'shop',
  goods_create: 'goods_create',
  goods_list: 'goods_list',
  order_list: 'order_list',
  account_center: 'account_center',
  restock_list: 'restock_list',
  all_notice: 'all_notice',
};

const Header = observer((props) => {
  const {
    application,
    application: { menuCollapsed, user },
  } = useStores();

  const { pathname } = useLocation();

  const toggle = () => {
    application.updateMenuCollapsed(!menuCollapsed);
  };

  const getDefaultSelectKeys = () => {
    const open = {};
    if (pathname.includes(router.home)) {
      open.open = ['sub1a'];
      open.select = ['sub1a-1'];
      return open;
    }
    if (pathname.includes(router.goods_create)) {
      open.open = ['sub2a'];
      open.select = ['sub2a-1'];
      return open;
    }
    if (pathname.includes(router.goods_list)) {
      open.open = ['sub2a'];
      open.select = ['sub2a-2'];
      return open;
    }
    if (pathname.includes(router.order_list)) {
      open.open = ['sub3a'];
      open.select = ['sub3a-1'];
      return open;
    }
    if (pathname.includes(router.restock_list)) {
      open.open = ['sub3a'];
      open.select = ['sub3a-2'];
      return open;
    }
    if (pathname.includes(router.account_center)) {
      open.open = ['sub4a'];
      open.select = ['sub4a-1'];
      return open;
    }
    if (pathname.includes(router.all_notice)) {
      open.open = ['sub5a'];
      open.select = ['sub5a-1'];
      return open;
    }
    return open;
  };

  const keys = getDefaultSelectKeys();

  return (
    <div className={s.menu}>
      <Menu className={s.top} theme="light" defaultSelectedKeys={keys.select} defaultOpenKeys={keys.open} mode="inline">
        <SubMenu
          key="sub1a"
          title={
            <>
              <ShopOutlined />
              <span>店铺管理</span>
            </>
          }
        >
          <Item key="sub1a-1">
            <Link to="/shop">我的店铺</Link>
          </Item>
        </SubMenu>
        <SubMenu
          key="sub2a"
          title={
            <>
              <ShoppingOutlined />
              <span>商品管理</span>
            </>
          }
        >
          <Item key="sub2a-1">
            <Link to="/goods_create">商品创建</Link>
          </Item>
          <Item key="sub2a-2">
            <Link to="/goods_list">商品管理</Link>
          </Item>
        </SubMenu>
        <SubMenu
          key="sub3a"
          title={
            <>
              <ProfileOutlined />
              <span>订单管理</span>
            </>
          }
        >
          <Item key="sub3a-1">
            <Link to="/order_list">售卖订单</Link>
          </Item>
          {user && user.shop_type === 0 && (
            <Item key="sub3a-2">
              <Link to="/restock_list">进货订单</Link>
            </Item>
          )}
        </SubMenu>

        <SubMenu
          key="sub4a"
          title={
            <>
              <AccountBookOutlined />
              <span>账户管理</span>
            </>
          }
        >
          <Item key="sub4a-1">
            <Link to="/account_center">账户中心</Link>
          </Item>
        </SubMenu>
        <SubMenu
          key="sub5a"
          title={
            <>
              <NotificationOutlined />
              <span>公告管理</span>
            </>
          }
        >
          <Item key="sub5a-1">
            <Link to="/all_notice">店铺公告</Link>
          </Item>
        </SubMenu>
      </Menu>
      <Menu mode="inline" theme="light" selectable={false}>
        <Menu.Divider />
        <Menu.Item key="1" icon={menuCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} onClick={toggle} />
      </Menu>
    </div>
  );
});

export default Header;
